import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import InvestigationLayout from '../../components/Investigation/InvestigationLayout';

export const InvestigationRouting = (props: LogicalRouteImportProps) => {
    return <LogicalRoute {...props} component={InvestigationLayout} />;
};
